export default __webpack_public_path__ + "static/media/Frame 2.d6195672.svg";